"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSpacesNonBreakable = makeSpacesNonBreakable;
var _constants = require("../constants");
/**
 * Replaces breaking spaces in the given string with non-breaking spaces.
 * @param value A string containg breaking space to be replaced
 * @returns Non-breakable string
 */
function makeSpacesNonBreakable(value) {
  return value.replaceAll(' ', _constants.NON_BREAKING_SPACE_CHARACTER);
}
//# sourceMappingURL=makeSpacesNonBreakable.js.map